import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { View } from 'react-native';
import { useBreakpoint } from '../../../../hooks';
import { isLastItem } from '../../../../utils';
import { Typography } from '../../../typography';
import { getLegendStyles } from './LegendStyle';
export var Legend = props => {
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true,
      allowMdAsLargeScreen: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var legendStyles = getLegendStyles(props, isSmallScreen);
  var data = props.data,
    type = props.type,
    _props$hideLegendSubt = props.hideLegendSubtext,
    hideLegendSubtext = _props$hideLegendSubt === void 0 ? false : _props$hideLegendSubt;
  var getLegendData = () => {
    var _a;
    var _legendArray = [];
    var datasets = data === null || data === void 0 ? void 0 : data.datasets;
    if (type == 'bar' || type == 'line') {
      (_a = data === null || data === void 0 ? void 0 : data.datasets) === null || _a === void 0 ? void 0 : _a.map((dataset, index) => {
        _legendArray.push({
          id: index,
          label: (dataset === null || dataset === void 0 ? void 0 : dataset.label) || '',
          bgColor: dataset === null || dataset === void 0 ? void 0 : dataset.borderColor
        });
      });
    } else {
      var labels = data === null || data === void 0 ? void 0 : data.labels;
      var total = 0;
      datasets === null || datasets === void 0 ? void 0 : datasets.map(dataset => {
        var _a;
        (_a = dataset === null || dataset === void 0 ? void 0 : dataset.data) === null || _a === void 0 ? void 0 : _a.map((_, j) => {
          var value = typeof (dataset === null || dataset === void 0 ? void 0 : dataset.data[j]) === 'number' ? dataset === null || dataset === void 0 ? void 0 : dataset.data[j] : 0;
          total += value;
          var label = labels[j] || '';
          var percentage = (value / total * 100).toFixed(2);
          var backgroundColor = dataset === null || dataset === void 0 ? void 0 : dataset.backgroundColor[j];
          _legendArray.push({
            label: label,
            bgColor: backgroundColor,
            subText: value + " [" + percentage + "%]"
          });
        });
      });
    }
    return _legendArray;
  };
  var legendData = getLegendData();
  return _jsx(View, Object.assign({
    style: [type === 'doughnut' ? legendStyles === null || legendStyles === void 0 ? void 0 : legendStyles.dounutLegendContainer : legendStyles === null || legendStyles === void 0 ? void 0 : legendStyles.container]
  }, {
    children: legendData === null || legendData === void 0 ? void 0 : legendData.map((singleLegend, index) => {
      return _jsxs(View, Object.assign({
        style: [legendStyles === null || legendStyles === void 0 ? void 0 : legendStyles.legendContainer, !isLastItem(legendData, index) && (legendStyles === null || legendStyles === void 0 ? void 0 : legendStyles.legendMargin), legendStyles.legendMarginBottom]
      }, {
        children: [_jsx(View, {
          style: [legendStyles.legendBox, {
            backgroundColor: singleLegend === null || singleLegend === void 0 ? void 0 : singleLegend.bgColor
          }]
        }), _jsx(Typography, {
          text: singleLegend === null || singleLegend === void 0 ? void 0 : singleLegend.label,
          type: "body-single-line-md"
        }), !hideLegendSubtext && _jsx(Typography, {
          text: singleLegend === null || singleLegend === void 0 ? void 0 : singleLegend.subText,
          type: "body-para-sm",
          style: {
            marginLeft: 4
          }
        })]
      }), "legend-" + index);
    })
  }));
};